import { useRouter } from 'next/router';
import * as React from 'react';

import { FormSettings, Github, Home, Integrations, TaskTemplate } from './components';
import { useFileExploreStore } from './store';

const { useEffect } = React;

export const FileExplore = (): JSX.Element => {
  const { closeExploreMenu, navigation, setFileOption, setHasExpolreMenu } = useFileExploreStore();
  useEffect(() => {
    const handleOnKeyDown = (e: KeyboardEvent) => {
      if (e.key == 'Escape') {
        closeExploreMenu();
        setFileOption(false);
        setHasExpolreMenu(false);
      }
    };
    document.addEventListener('keydown', handleOnKeyDown);
    return () => document.removeEventListener('keydown', handleOnKeyDown);
  }, []);

  const loadComponentPage = (navigation) => {
    switch (navigation) {
      case 'home':
        return <Home />;
      case 'integrations':
        return <Integrations />;
      case 'form-settings':
        return <FormSettings />;
      case 'github':
        return <Github />;
      case 'task-templates':
        return <TaskTemplate />;
      default:
        return <div />;
    }
  };

  return (
    <div className="h-full overflow-y-scroll no-scrollbar">{loadComponentPage(navigation)}</div>
  );
};
